<template>
  <div v-if="false"></div>
</template>
<script>
export default {
  props: {
    searchEntity: {
      required: true
    }
  },
  setup (props) {
    return {
    }
  }
}
</script>
